export default "__VITE_ASSET__CG$9sdtD__"